<template>
  <div class="integration">
    <banner clazz="integration-banner" url="integration" hasDivider>
      <template slot="buttons">
        <el-button class="banner-button" round @click="goTrial('kaifangpingtai-banner-tiyan')">申请体验</el-button>
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
      </template>
    </banner>
    <div class="integration-section1">
      <div class="section1-content">
        <h1 class="section1-title">联合合作伙伴及资源，只为您提供较好业务体验</h1>
        <div class="section1-divider"></div>
        <div class="integration-intro">
          <p>开放平台计划，将在采购供应资源、供应商风险舆情管控、电子签章、电子发票等领域中，甄选优质第三方，
            融合AI、数据挖掘等技术，打造云商业生态圈，为您搭建较好业务实践场景。
          </p>
        </div>
        <hover-button clazz="consult-button" text="申请体验"
                      @click.native="goTrial('kaifangpingtai-yewu-tiyan')"></hover-button>
      </div>
    </div>
    <div class="integration-section2">
      <div class="section2-content">
        <h1 class="section2-title">海量资源，互惠共赢</h1>
        <div class="section2-divider"></div>
        <div class="integration-intro">
          <p>甄云采购商城，整合多方供应资源，如京东企业购、得力文具、工业品等优质供应货源，一站打通众多电商平台；
            甄云工具库，整合企业征信、电子签章、OCR识别、电子发票等数字化工具，与甄云SRM无缝融合。
          </p>
        </div>
        <div class="section2-con clearfix">
          <div class="section2-con-content fl">
            <img src="../../assets/img/integration/icon1.png" alt="垂直行业B2B"/>
            <span>垂直行业B2B</span>
          </div>
          <div class="section2-con-content fl">
            <img src="../../assets/img/integration/icon2.png" alt="区域B2B平台"/>
            <span>区域B2B平台</span>
          </div>
          <div class="section2-con-content fl">
            <img src="../../assets/img/integration/icon3.png" alt="批发市场"/>
            <span>批发市场</span>
          </div>
          <div class="section2-con-content fl">
            <img src="../../assets/img/integration/icon4.png" alt="全球资源"/>
            <span>全球资源</span>
          </div>
        </div>
      </div>
    </div>

    <div class="integration-section3">
      <div class="section3-content">
        <div class="section3-title">开放平台流程一览图</div>
        <div class="section3-divider"></div>
        <div class="integration-intro">
          <p>采购商场，与电商平台打通，降本增效</p>
        </div>
        <div class="section3-photo">
          <img src="../../assets/img/integration/tupian.png" alt="采购商场"/>
        </div>
      </div>
    </div>

    <div class="integration-section4">
      <div class="section4-content">
        <div class="section4-title">采购甄云采购管理系统，您能得到什么？</div>
        <div class="section4-divider"></div>
        <div class="section4-boxlist">
          <div class="box first">
            <img class="icon" src="../../assets/img/integration/icon1-1.png" alt="企业采购集中管理"/>
            <h1 class="title">企业采购集中管理</h1>
            <div>
              <div class="divider"></div>
            </div>
            <div class="text">
              <p class="hidden-content">甄云商城一站式企业采购平台，连接多个第三方...</p>
              <p class="full-content">甄云商城一站式企业采购平台，连接多个第三方采购平台，企业可实现采购集中化和采购信息化一站式管理</p>
            </div>
            <div class="tail"></div>
          </div>
          <div class="box second">
            <img class="icon" src="../../assets/img/integration/icon1-2.png" alt="择优采购，节约成本"/>
            <h1 class="title">择优采购，节约成本</h1>
            <div>
              <div class="divider"></div>
            </div>
            <div class="text">
              <p class="hidden-content">甄云商城连接京东、震坤行、工品汇...</p>
              <p class="full-content">甄云商城连接京东、震坤行、工品汇等优质采购平台，海量供货，快速比价，择优采购，降低采购成本</p>
            </div>
            <div class="tail"></div>
          </div>
          <div class="box third">
            <img class="icon" src="../../assets/img/integration/icon1-3.png" alt="企业自定义商品货架"/>
            <h1 class="title">企业自定义商品货架</h1>
            <div>
              <div class="divider"></div>
            </div>
            <div class="text">
              <p class="hidden-content">支持企业框架协议物料上架，企业可以形成自己的...</p>
              <p class="full-content">支持企业框架协议物料商家，企业可以形成自己的“协议商品目录和价格”，方便采购人员或员工根据权限自助查询并申购</p>
            </div>
            <div class="tail"></div>
          </div>
          <div class="box fourth">
            <img class="icon" src="../../assets/img/integration/icon1-4.png" alt="甄云采购商城"/>
            <h1 class="title">甄云采购商城</h1>
            <div>
              <div class="divider"></div>
            </div>
            <div class="text">
              <p class="hidden-content">甄云商业平台可与企业内部的ERP系统无缝集成，实现...</p>
              <p class="full-content">甄云商业平台可与企业内部的ERP系统无缝集成，实现企业采购流程信息化的全线上管理，
                一站式服务平台，提高企业采购效率</p>
            </div>
            <div class="tail-line">
              <div class="tail"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="integration-section5">
      <h1 class="section2-title">云平台资源，帮他们节省了大量支出</h1>
      <div class="section2-divider dib"></div>
      <div>
        <div class="section2-systemlist tl dib">
          <span class="expand-content dib">
            <div class="expandItem tc dib" :class="index === 0 ? 'expand' : ''" @mouseenter="listExpandOn(index)"
                 @mouseleave="listExpandOff" @click="goClientDetail(item.id, item.status)"
                 @touchstart="listExpandOn(index)" @touchend="listExpandOn(index)"
                 :style="{'backgroundImage': item.kaif_img ? 'url(' + $global.globalPath + item.kaif_img + ')' : ''}"
                 v-for="(item, index) in expandItemList">
              <div class="expandItemMask">
                <img class="expandItemIcon" v-lazy="$global.globalPath + item.kaif_logo" :alt="item.title"/>
                <div class="expandItemTextContainer">
                  <p class="expandItemText dib textContent">{{index === 0 ? item.kaif_describe : item.title}}</p>
                  <p class="expandItemText textFooter tl">{{item.kaif_seo ? '——' + item.kaif_seo : ''}}</p>
                  <!-- <p class="expandShowDetail tc">查看详情
                    <i class="el-icon-d-arrow-right"></i>
                  </p> -->
                </div>
              </div>
          </div>
          </span>
          <div class="expandItem static tc dib" @click="listMove">
            <img class="expandItemIcon" src="../../assets/img/purchaseManage/arrow@2x.png" alt="expandItemIcon"/>
          </div>
        </div>
      </div>
      <hover-button text="获取更多案例" clazz="get-detail dib" @click.native="goMoreCase"></hover-button>
    </div>
  </div>
</template>

<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'
import * as className from '../../assets/js/dom'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'Integration',
  metaInfo () {
    return {
      title: this.$seo.integration.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.integration.keywords
      },
      {
        name: 'description',
        content: this.$seo.integration.description
      }]
    }
  },
  components: {
    hoverButton,
    banner
  },
  data () {
    return {
      expandItemList: [
        {
          id: '1',
          status: '0',
          title: '加载中',
          kaif_describe: '当您看到这则信息，请检查网络链接',
          kaif_img: '',
          kaif_logo: '',
          kaif_seo: ''
        },
        {
          id: '2',
          status: '0',
          title: '加载中',
          kaif_describe: '当您看到这则信息，请检查网络链接2',
          kaif_img: '',
          kaif_logo: '',
          kaif_seo: ''
        },
        {
          id: '3',
          status: '0',
          title: '加载中',
          kaif_describe: '当您看到这则信息，请检查网络链接3',
          kaif_img: '',
          kaif_logo: '',
          kaif_seo: ''
        },
        {
          id: '4',
          status: '0',
          title: '加载中',
          kaif_describe: '当您看到这则信息，请检查网络链接4',
          kaif_img: '',
          kaif_logo: '',
          kaif_seo: ''
        }
      ],
      expandController: 0
    }
  },
  methods: {
    // 申请
    goTrial (code) {
      this.openRegister(false, code)
    },
    // 更多案例
    goMoreCase () {
      let routeObj = this.$router.resolve({ path: '/clientele' })
      window.open(routeObj.href, '_blank')
    },
    getExpandItemList () {
      this.$api.post('/cases/get_cases', { webname: 'integration', cases_sum: '' }, (r) => {
        if (r.code === 0) {
          this.expandItemList = r.data
          if (this.expandItemList.length > 8) {
            this.expandItemList = this.expandItemList.slice(0, 8)
          }
        } else {
          this.$message.error(r.message)
        }
      })
    },
    listMove (event) {
      if (this.expandItemList.length <= 4) {
        return false
      }
      let content = document.getElementsByClassName('expandItem')
      let dom = document.getElementsByClassName('static')[0]
      let evt = window.event || event
      if (this.$func.getCurrentBrowser() === 'IE9') {
        evt.cancelBubble = true // 阻止IE冒泡
      } else {
        evt.stopPropagation() // 阻止通用浏览器冒泡
      }
      let list = document.getElementsByClassName('expand-content')
      if (this.moveList) {
        className.addClass(dom, 'is-actived')
        className.addClass(list[0], 'is-moved')
        // 减去的5中包括 展示用的4个item和导航键头的1个static
        list[0].style.right = 175 * (content.length - 5) + 'px'
        let res = (content.length - 1) % 4 ? (content.length - 1) % 4 : 4
        if (this.currentExpand() < res) {
          this.listExpand(res)
        }
      } else {
        className.removeClass(dom, 'is-actived')
        className.removeClass(list[0], 'is-moved')
        list[0].style.right = ''
        if (this.currentExpand() > 3) {
          this.listExpand(0)
        }
      }
      this.moveList = !this.moveList
    },
    currentExpand () {
      let dom = document.getElementsByClassName('expandItem')
      for (let i = 0; i < dom.length - 1; i++) {
        if (className.hasClass(dom[i], 'expand')) {
          return i
        }
      }
      return 0
    },
    listExpandOn (index) {
      this.expandController = setTimeout(() => {
        this.listExpand(index)
      }, 100)
    },
    listExpandOff () {
      clearTimeout(this.expandController)
    },
    listExpand (index) {
      let dom = document.getElementsByClassName('expandItem')
      for (let i = 0; i < dom.length - 1; i++) {
        let contentDom = dom[i].getElementsByClassName('textContent')[0]
        //          let imgDom = dom[i].getElementsByClassName('expandItemIcon')[0]
        if (i !== index) {
          className.removeClass(dom[i], 'expand')
          contentDom.innerText = this.expandItemList[i].title
          //            imgDom.src = this.$global.globalPath + this.expandItemList[i].logo
        } else {
          className.addClass(dom[i], 'expand')
          contentDom.innerText = this.expandItemList[i].kaif_describe
        }
      }
    },
    goClientDetail (id, status) {
      if (status === '0') {
        let routeUrl = this.$router.resolve({
          name: 'ClienteleDetile',
          query: {
            id: id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (status === '1') {
        this.$api.post('/cases/twenty_four_hour', '', (r) => {
          if (r.code === 0) {
            if (r.data === 1) {
              let routeUrl = this.$router.resolve({
                name: 'ClienteleDetile',
                query: {
                  id: id
                }
              })
              window.open(routeUrl.href, '_blank')
            } else {
              this.openRegister(false, 3)
            }
          } else {
            this.$message.error(r.message)
          }
        })
      } else {

      }
    }
  },
  created () {
    this.getExpandItemList()
  }
}
</script>

<style lang="scss">
  @import "../../../static/css/integration.scss";
</style>



// WEBPACK FOOTER //
// integration.vue?4a99d1e1